import React from 'react';

import { rangePresets } from '@gogame/intl-ts';

import { usePerformance } from 'scenes/Gallery/GalleryPage/Concepts/data';
import Performance from 'scenes/Gallery/components/Performance';

const ConceptPerformance = ({ conceptId, columns }) => {
  const { data, isLoading, isRefetching } = usePerformance({
    id: conceptId,
    startDate: rangePresets.LAST_30_DAYS.value[0],
    endDate: rangePresets.LAST_30_DAYS.value[1],
  });

  return (
    <Performance
      type={'Concept'}
      id={conceptId}
      data={data}
      isLoading={isLoading}
      isRefetching={isRefetching}
      columns={columns}
    />
  );
};

export default ConceptPerformance;
